import React, { useEffect } from 'react';

const TaskGroupListeners = ({ eventEmitter, applyStoreAction }) => {
    const listen = () => {
        eventEmitter.on('task_group_added', taskGroup => {
            applyStoreAction({
                type: 'TASK_GROUP_ADD_SOCKET',
                payload: { taskGroup }
            });
        });

        eventEmitter.on('task_group_removed', taskGroup => {
            applyStoreAction({
                type: 'TASK_GROUP_REMOVE_SOCKET',
                payload: { taskGroupId: taskGroup.id }
            });
        });

        eventEmitter.on('task_group_edited', taskGroup => {
            applyStoreAction({
                type: 'TASK_GROUP_UPDATE_SOCKET',
                payload: { taskGroupId: taskGroup.id, taskGroup }
            });
        });

        eventEmitter.on('task_groups_reorder', ({ task_groups }) => {
            applyStoreAction({
                type: 'TASK_GROUPS_REORDER_SOCKET',
                payload: { taskGroups: task_groups }
            });
        });

    }

    useEffect(listen, []);

    return null;
}

export default TaskGroupListeners;
